import { render, staticRenderFns } from "./SystemCatalogue.vue?vue&type=template&id=78cf73b6&scoped=true"
import script from "./SystemCatalogue.vue?vue&type=script&lang=js"
export * from "./SystemCatalogue.vue?vue&type=script&lang=js"
import style0 from "./SystemCatalogue.vue?vue&type=style&index=0&id=78cf73b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cf73b6",
  null
  
)

export default component.exports